module.exports = __webpack_public_path__ + "img/luci-disco.3ae0d220.jpg";